"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsReviewModalOpen = void 0;

var getIsReviewModalOpen = function getIsReviewModalOpen(state) {
  return state.reviewInputInfo.get('open');
};

exports.getIsReviewModalOpen = getIsReviewModalOpen;